import { Injectable } from '@angular/core';
import { ToastController, LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  public loadingWindow: any;

  constructor(
      public loadingController: LoadingController,
      public toastController: ToastController,
  ) { }

  async presentLoadingWindow(msg: string, id?: string) {
    this.loadingWindow = await this.loadingController.create({
      message: msg,
      id: id
    });
    return this.loadingWindow.present();
  }

  async displayToastWithMessage(prefixText: string = '', messageContent: string='') {
    var message: string = (prefixText ? prefixText + ' ' : '') + (messageContent ? messageContent + ' ' : '');
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'bottom',
      buttons: [{
        side: 'start',
        icon: 'checkmark-circle',
        text: 'OK'
      }]
    });
    toast.present();
  }

  async savedSuccessfully(prefixText: string = '') {
    var message: string = (prefixText ? prefixText + ' ' : '') + 'Saved Successfully'
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'bottom',
      buttons: [{
        side: 'start',
        icon: 'checkmark-circle',
        text: 'OK'
      }]
    });
    toast.present();
  }

  async addedSuccessfully(prefixText: string = '') {
    var message: string = (prefixText ? prefixText + ' ' : '') + 'Added Successfully'
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'bottom',
      buttons: [{
        side: 'start',
        icon: 'checkmark-circle',
        text: 'OK'
      }]
    });
    toast.present();
  }

  async updatedSuccessfully(prefixText: string = '') {
    var message: string = (prefixText ? prefixText + ' ' : '') + 'Updated Successfully'
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'bottom',
      buttons: [{
        side: 'start',
        icon: 'checkmark-circle',
        text: 'OK'
      }]
    });
    toast.present();
  }

  async deletedSuccessfully(prefixText: string = '') {
    var message: string = (prefixText ? prefixText + ' ' : '') + 'Deleted Successfully'
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'bottom',
      buttons: [{
        side: 'start',
        icon: 'checkmark-circle',
        text: 'OK'
      }]
    });
    toast.present();
  }

  async removedSuccessfully(prefixText: string = '') {
    var message: string = (prefixText ? prefixText + ' ' : '') + 'Removed Successfully'
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'bottom',
      buttons: [{
        side: 'start',
        icon: 'checkmark-circle',
        text: 'OK'
      }]
    });
    toast.present();
  }

  async dismissLoadingWindowById(id: string){
    await this.loadingController.dismiss(null, null, id);
  }
}
